import { render } from "./Limit.vue?vue&type=template&id=5226160f&scoped=true&ts=true"
import script from "./Limit.vue?vue&type=script&lang=ts"
export * from "./Limit.vue?vue&type=script&lang=ts"

import "./Limit.vue?vue&type=style&index=0&id=5226160f&lang=scss&scoped=true"

import exportComponent from "D:\\project\\anet\\new2h5\\libo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5226160f"]])

export default __exports__